"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWBShareInfo = exports.wbShare = exports.pageShare = void 0;
/* eslint-disable no-empty-function */
/** ****** 分享 ********/
var object_assign_1 = __importDefault(require("object-assign"));
var tools_1 = require("./tools");
// import {is58App} from "./appTools";
// import { FUSE_VERSION_STRING } from "../const/app";
var methods_1 = require("../appMethods/methods");
var pageShare = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.title, title = _c === void 0 ? "58车_让车生活更简单" : _c, _d = _b.desc, desc = _d === void 0 ? document.title : _d, _e = _b.imgurl, imgurl = _e === void 0 ? "https://icon.xgo-img.com.cn/logo/m/logoche.jpg" : _e, _f = _b.linkurl, linkurl = _f === void 0 ? window.location.href : _f, _g = _b.success, success = _g === void 0 ? function () { } : _g, _h = _b.cancel, cancel = _h === void 0 ? function () { } : _h, _j = _b.fail, fail = _j === void 0 ? function () { } : _j, _k = _b.wbShareClickFun, wbShareClickFun = _k === void 0 ? function () { } : _k, _l = _b.shareProgram, shareProgram = _l === void 0 ? false : _l, _m = _b.shareIcon, shareIcon = _m === void 0 ? false : _m, _o = _b.programParam, programParam = _o === void 0 ? {
        pathKey: "home",
        param: {}
    } : _o, _p = _b.posterUrl, posterUrl = _p === void 0 ? "" : _p;
    var data = {
        title: title,
        desc: desc,
        imgurl: imgurl,
        linkurl: linkurl,
        success: success,
        cancel: cancel,
        fail: fail,
        wbShareClickFun: wbShareClickFun,
        shareProgram: shareProgram,
        programParam: programParam,
        shareIcon: shareIcon,
        posterUrl: posterUrl
    };
    if (methods_1.getAppType() != "browser") {
        // 58app分享
        methods_1.loadAPPSDK()
            .then(function () {
            setWbShare(data);
        })
            .catch(function (err) {
            console.log("share loadAPPSDK error", err);
        });
    }
    else if (typeof wx == "undefined") {
        tools_1.loadScript({ url: "//res.wx.qq.com/open/js/jweixin-1.0.0.js" }).then(function () {
            wxShare(data);
        });
    }
    else {
        wxShare(data);
    }
};
exports.pageShare = pageShare;
/** 58app 页面右上角分享功能
 * @param {object} data
 * @param {string}   data.title         分享title    默认值：58车_让车生活更简单
 * @param {string}   data.desc          分享描述文案  默认值：页面title
 * @param {string}   data.imgurl        分享图片      默认值：https://icon.xgo-img.com.cn/logo/m/logoche.jpg
 * @param {string}   data.linkurl       分享链接      默认值：当前页面url
 * @param {function} data.success       分享成功回调函数
 * @param {function} data.cancel        分享取消回调函数
 * @param {function} data.fail          分享失败回调函数
 * @param {boolean}  data.shareProgram  58app分享中微信是否是分享小程序 默认false
 * @param {object}   data.programParam  分享小程序相关参数 pathKey 小程序页面key值    param 小程序页面相关参数
 */
function setWbShare(data) {
    var shareIconStr = data.shareIcon ? "horizontal" : ""; // 右上角分享是按钮还是文字
    var shareIconUrl = data.shareIcon ? "share" : "";
    window.XINCHEAPP.action.extendBtn([
        {
            key: "share",
            txt: "分享",
            icon: shareIconUrl
        }
    ], function () {
        // 58app 点击右上角分享执行
        data.wbShareClickFun();
        exports.wbShare(data);
    }, shareIconStr);
}
/** 58app 分享功能
 * @param {object} data
 * @param {string}   data.title         分享title    默认值：58车_让车生活更简单
 * @param {string}   data.desc          分享描述文案  默认值：页面title
 * @param {string}   data.imgurl        分享图片      默认值：https://icon.xgo-img.com.cn/logo/m/logoche.jpg
 * @param {string}   data.linkurl       分享链接      默认值：当前页面url
 * @param {function} data.success       分享成功回调函数
 * @param {function} data.cancel        分享取消回调函数
 * @param {function} data.fail          分享失败回调函数
 * @param {boolean}  data.shareProgram  58app分享中微信是否是分享小程序 默认false
 * @param {object}   data.programParam  分享小程序相关参数 pathKey 小程序页面key值    param 小程序页面相关参数
 */
var wbShare = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.title, title = _c === void 0 ? "58车_让车生活更简单" : _c, _d = _b.desc, desc = _d === void 0 ? document.title : _d, _e = _b.imgurl, imgurl = _e === void 0 ? "https://icon.xgo-img.com.cn/logo/m/logoche.jpg" : _e, _f = _b.linkurl, linkurl = _f === void 0 ? window.location.href : _f, _g = _b.success, success = _g === void 0 ? function (str) { } : _g, _h = _b.cancel, cancel = _h === void 0 ? function () { } : _h, _j = _b.fail, fail = _j === void 0 ? function () { } : _j, _k = _b.shareProgram, shareProgram = _k === void 0 ? false : _k, _l = _b.programParam, programParam = _l === void 0 ? {
        pathKey: "home",
        param: {}
    } : _l, _m = _b.posterUrl, posterUrl = _m === void 0 ? "" : _m;
    var param = {
        shareInfo: {
            title: title,
            content: desc,
            img_url: imgurl,
            url: linkurl,
            placeholder: ""
        },
        shareProgram: shareProgram,
        programParam: programParam,
        posterUrl: posterUrl
    };
    methods_1.loadAPPSDK().then(function () {
        exports.getWBShareInfo(param).then(function (arr) {
            // 唤起58分享之前先去执行同意58协议的事情
            /**
             * 先判断是不是58同城
             * 在判断版本号是不是 10.21.0
             *
             */
            var is58App = methods_1.getAppType() === "58app";
            if (is58App) {
                methods_1.judge58Version("10.21.0")
                    .then(function () {
                    // window.XINCHEAPP.invoke('get_privacy_access', (code) => {
                    //   // 已授权
                    //   if(parseInt(code) === 1) {
                    //     openShare(arr, success, cancel)
                    //   } else {
                    //     // 未授权
                    //     window.XINCHEAPP.invoke('show_privacy_access', {
                    //       message: '继续使用该功能，请先阅读并授权隐私协议'
                    //     }, (codes) => {
                    //       if(parseInt(codes) === 1) {
                    //         // 已授权
                    //         openShare(arr, success, cancel)
                    //       } else {
                    //         // 未授权，提示用户未授权，无法使用该功能
                    //       }
                    //     })
                    //   }
                    // })
                    window.XINCHEAPP.invoke("get_user_info", { key: "accessmode" }, 
                    // eslint-disable-next-line max-nested-callbacks
                    function (value) {
                        if (value === "guest") {
                            window.XINCHEAPP.invoke("show_privacy_access", {
                                message: "授权用户协议"
                            }, 
                            // eslint-disable-next-line max-nested-callbacks
                            function (code) {
                                if (parseInt(code) === 1) {
                                    openShare(arr, success, cancel);
                                }
                                else {
                                    // 未授权，提示用户未授权，无法使用该功能
                                    window.XINCHEAPP.action.toast("未授权隐私协议，无法使用该功能");
                                }
                            });
                        }
                        else {
                            // 10.21.0灰度包 不存在该action，或者用户已授权，执行正常的业务逻辑
                            openShare(arr, success, cancel);
                        }
                    });
                })
                    .catch(function (err) {
                    // 说明版本小于10.21.0 执行旧操作
                    openShare(arr, success, cancel);
                });
            }
            else {
                // 不在58app
                openShare(arr, success, cancel);
            }
        });
    });
};
exports.wbShare = wbShare;
var openShare = function (arr, success, cancel) {
    window.XINCHEAPP.action.share(arr, function (state, source) {
        if (state == 0) {
            // 分享成功
            var sourcestr = typeof source == "undefined" ? "" : source;
            success(sourcestr);
        }
        if (state == 1 || state == 4) {
            // 分享失败
            fail();
        }
        if (state == 2) {
            // 取消分享
            cancel();
        }
    });
};
/**
 * 获取58app 分享配置信息
 * @param {array}   type          分享类型 默认 微信 朋友圈 QQ 新浪
 * @param {object}  shareInfo     分享内容
 * @param {boolean} shareProgram  微信是否是分享小程序
 * @param {object} programParam   分享小程序相关参数 pathKey 小程序页面key值    param 小程序页面相关参数
 */
var getWBShareInfo = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.type, type = _c === void 0 ? ["WEIXIN", "FRIENDS", "QQ", "SINA"] : _c, _d = _b.shareInfo, shareInfo = _d === void 0 ? {
        title: "58车_让车生活更简单",
        content: document.title,
        img_url: "https://icon.xgo-img.com.cn/logo/m/logoche.jpg",
        url: window.location.href,
        placeholder: ""
    } : _d, _e = _b.shareProgram, shareProgram = _e === void 0 ? false : _e, _f = _b.programParam, programParam = _f === void 0 ? {
        pathKey: "home",
        param: {}
    } : _f, _g = _b.posterUrl, posterUrl = _g === void 0 ? "" : _g;
    return new Promise(function (resolve, reject) {
        // @ts-ignore
        if (typeof window.programPath == "undefined") {
            tools_1.loadScript({
                url: "//static.xgo-img.com.cn/mod/program/info.js"
            }).then(function () {
                resolve(combinShareInfo({
                    type: type,
                    shareInfo: shareInfo,
                    shareProgram: shareProgram,
                    programParam: programParam,
                    posterUrl: posterUrl
                }));
            });
        }
        else {
            resolve(combinShareInfo({
                type: type,
                shareInfo: shareInfo,
                shareProgram: shareProgram,
                programParam: programParam,
                posterUrl: posterUrl
            }));
        }
    });
};
exports.getWBShareInfo = getWBShareInfo;
// 组合信息58app分享配置信息
function combinShareInfo(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.type, type = _c === void 0 ? ["WEIXIN", "FRIENDS", "QQ", "SINA"] : _c, _d = _b.shareInfo, shareInfo = _d === void 0 ? {
        title: "58车_让车生活更简单",
        content: document.title,
        img_url: "https://icon.xgo-img.com.cn/logo/m/logoche.jpg",
        url: window.location.href,
        placeholder: ""
    } : _d, _e = _b.shareProgram, shareProgram = _e === void 0 ? false : _e, _f = _b.programParam, programParam = _f === void 0 ? {
        pathKey: "home",
        param: {}
    } : _f, _g = _b.posterUrl, posterUrl = _g === void 0 ? "" : _g;
    if (typeof window.programPath == "undefined") {
        return false;
    }
    var shareArr = [];
    var fuseVersionFlag = methods_1.judgeFuseVersion(); //  是否大于整合版本
    var istown = methods_1.getAppType() == "58town";
    var productorid = tools_1.getCookie("productorid");
    var is58cheapp = navigator.userAgent.toLocaleLowerCase().indexOf("wubaqiche") != -1 ||
        productorid == "52" ||
        productorid == "53" ||
        productorid == '"53"'; // 是58汽车独立app
    if ((istown || is58cheapp) && !fuseVersionFlag) {
        // 同镇和独立app仅支持微信 qq
        type = ["WEIXIN", "FRIENDS"];
    }
    else if (shareProgram) {
        var path = "/" + window.programPath[programParam.pathKey].path;
        for (var key in programParam.param) {
            path =
                path +
                    (path.indexOf("?") != -1 ? "&" : "?") +
                    key +
                    "=" +
                    programParam.param[key];
        }
        var programInfo = __assign({ shareto: "WEIXIN", type: "wxminipro", wxminiproid: window.appKey.wxOriginalId, wxminipropath: path, wxminipropic: shareInfo.img_url, versiontype: "0", 
            // @ts-ignore
            url: window.location.href }, shareInfo);
        shareArr.push(programInfo);
    }
    type.map(function (item) {
        if (!(item == "WEIXIN" && shareProgram && (!istown || fuseVersionFlag) && !is58cheapp)) {
            shareArr.push(object_assign_1.default({ shareto: item }, shareInfo));
        }
    });
    if (posterUrl && (!istown || fuseVersionFlag) && !is58cheapp) {
        // 生成海报
        shareArr.push({
            shareto: "CHART",
            jumpprotocol: posterUrl
        });
    }
    return shareArr;
}
function wxShare(data) {
    // 微信分享
    var wxAPI = "//service.58che.com/Wxshare/share/";
    // 配置及刷新微信分享数据
    function setShareData(shareData) {
        // 分享朋友圈配置
        var shareTimeline = {
            title: shareData.title,
            link: shareData.linkurl,
            imgUrl: shareData.imgurl,
            trigger: function (res) {
                //
            },
            success: function (res) {
                // 用户确认分享后执行的回调函数
                shareData.success();
            },
            cancel: function (res) {
                // 用户取消分享后执行的回调函数
                shareData.cancel();
            },
            fail: function (res) {
                shareData.fail();
            }
        };
        // 分享好友配置
        var shareFriend = {
            title: shareData.title,
            desc: shareData.desc,
            link: shareData.linkurl,
            imgUrl: shareData.imgurl,
            type: "",
            dataUrl: "",
            success: function () {
                // 用户确认分享后执行的回调函数
                shareData.success();
            },
            trigger: function (res) {
                //
            },
            cancel: function () {
                // 用户取消分享后执行的回调函数
                shareData.cancel();
            },
            fail: function (res) {
                shareData.fail();
            }
        };
        wx.onMenuShareTimeline(shareTimeline);
        wx.onMenuShareAppMessage(shareFriend);
    }
    // 初始化
    wx.ready(function () {
        var shareData = {
            title: data.title,
            desc: data.desc,
            link: data.linkurl,
            imgurl: data.imgurl,
            success: data.success,
            cancel: data.cancel,
            fail: data.fail
        };
        setShareData(shareData);
    });
    jsonp(wxAPI, {
        url: location.href.split("#")[0].replace(/&/gi, "@")
    }, "callback", function (json) {
        if (!json) {
            return;
        }
        if (json) {
            wx.config({
                debug: false,
                appId: json.appId,
                timestamp: json.timestamp,
                nonceStr: json.nonceStr,
                signature: json.signature,
                jsApiList: [
                    "checkJsApi",
                    "onMenuShareTimeline",
                    "onMenuShareAppMessage",
                    "onMenuShareQQ",
                    "onMenuShareWeibo"
                ]
            });
            wx.error(function (res) { });
        }
    });
}
function jsonp(url, data, cbName, fnSucc) {
    if (typeof cbName != "function") {
        var fnName_1 = "jsonp_" + Math.random();
        fnName_1 = fnName_1.replace(".", "");
        window[fnName_1] = function () {
            fnSucc && fnSucc.apply(this, arguments);
            oHead.removeChild(oS);
            window[fnName_1] = null;
        };
        data[cbName] = fnName_1;
    }
    var arr = [];
    for (var i in data) {
        arr.push(i + "=" + data[i]);
    }
    var str = url.indexOf("?") == -1
        ? url + "?" + arr.join("&")
        : url + "&" + arr.join("&"), oS = document.createElement("script"), oHead = document.getElementsByTagName("head")[0];
    oS.src = encodeURI(str);
    oHead.appendChild(oS);
    if (typeof cbName != "function") {
        return;
    }
    oS.onload = function () {
        cbName && cbName.apply();
    };
}
